export const common = {
  nav: {
    home: 'Home',
    products: 'Produkte',
    electricFireplaces: 'Elektrische Kamine',
    wallFireplaces: 'Freistehende Kamine',
    builtInFireplaces: 'Einbaukamine',
    threeSidedFireplaces: '3-seitige Kamine',
    panoramaFireplaces: 'Panorama Kamine',
    waterVaporFireplaces: 'Wasserdampf Kamine',
    accessories: 'Zubehör',
    inspiration: 'Inspiration',
    becomeDealer: 'Händler werden',
    about: 'Über Dutch Fires',
    support: 'Support',
    contact: 'Kontakt',
    categories: {
      wallFireplaces: 'Freistehende Kamine',
      builtIn: 'Einbaukamine',
      threeSided: '3-seitige Kamine',
      panorama: 'Panorama Kamine',
      waterVapor: 'Wasserdampf Kamine',
      accessories: 'Zubehör'
    }
  },
  hero: {
    badge: 'B2B GROSSHANDEL',
    title: 'Premium Elektrische Kamine',
    titleSecond: 'Für Profis',
    subtitle: 'Exklusiv erhältlich über unser offizielles europäisches Händlernetzwerk',
    ctaPrimary: 'Händler werden',
    ctaSecondary: 'Produkte ansehen',
    stats: {
      dealers: 'Händler',
      countries: 'Länder',
      certified: 'CE Zertifiziert'
    }
  },
  usps: {
    europeanBrand: {
      title: 'Europäisches Marke',
      description: 'Premium Qualität aus Europa'
    },
    fastDelivery: {
      title: 'Schnelle Lieferung',
      description: 'Zuverlässige Logistik in ganz Europa'
    },
    highMargins: {
      title: 'Hohe Margen',
      description: 'Attraktive Großhandelspreise'
    },
    fullSupport: {
      title: 'Vollständige Unterstützung',
      description: 'Marketing & technischer Support'
    }
  },
  categories: {
    title: 'Unsere Produktkategorien',
    wallFireplaces: 'Wandkamine',
    freestandingFireplaces: 'Freistehende Kamine',
    builtIn: 'Einbaukamine',
    threeSided: '3-seitige Kamine',
    panorama: 'Panorama Kamine',
    waterVapor: 'Wasserdampf Kamine',
    accessories: 'Zubehör',
    models: 'Modelle',
    viewProducts: 'Produkte ansehen',
    showAll: 'Alle Produkte anzeigen',
    clearFilter: 'Filter löschen'
  },
  whyDutchFire: {
    label: 'WARUM DUTCH FIRES',
    title: 'Ihr Partner in Premium Kaminlösungen',
    subtitle: 'Wir unterstützen Händler mit mehr als nur Produkten',
    wholesalePrices: {
      title: 'Großhandelspreise',
      description: 'Profitieren Sie von attraktiven Margen und wettbewerbsfähigen Preisen für Ihr Geschäft.',
      benefits: ['Gestaffelte Preisstruktur', 'Mengenrabatte verfügbar', 'Transparente Konditionen']
    },
    marketingSupport: {
      title: 'Marketing Support',
      description: 'Umfassendes Marketingmaterial und Unterstützung für Ihre Verkaufsaktivitäten.',
      benefits: ['Professionelle Produktfotos', 'Marketingmaterialien', 'Social Media Content']
    },
    technicalTraining: {
      title: 'Technische Schulung',
      description: 'Regelmäßige Schulungen und technischer Support für Sie und Ihr Team.',
      benefits: ['Online Schulungen', 'Produktdemonstrationen', '24/7 technischer Support']
    }
  },
  inspiration: {
    label: 'INSPIRATION',
    title: 'Dutch Fires in Aktion',
    subtitle: 'Entdecken Sie, wie unsere Händler Dutch Fires in ihre Projekte integrieren',
    viewProject: 'Projekt ansehen',
    viewPossibilities: 'Möglichkeiten entdecken',
    cta: 'Händler werden – Zugang zu allen Projekten erhalten',
    viewAll: 'Alle Projekte ansehen',
    projects: {
      luxuryPenthouse: 'Luxus Penthouse',
      hotelLobby: 'Hotel Lobby',
      modernOffice: 'Modernes Büro',
      restaurantAmbiance: 'Restaurant Ambiente',
      residentialVilla: 'Wohnvilla',
      showroom: 'Showroom'
    }
  },
  inspirationPage: {
    categories: {
      all: 'Alle Projekte',
      residential: 'Wohnbereich',
      hospitality: 'Gastgewerbe',
      commercial: 'Gewerbe'
    },
    cta: {
      title: 'Möchten Sie Dutch Fires in Ihren Projekten?',
      description: 'Werden Sie offizieller Händler und erhalten Sie Zugang zu exklusiver Projektunterstützung, Marketingmaterialien und technischer Beratung für Ihre Installationen.',
      button: 'Jetzt Händler werden'
    }
  },
  dealerBenefits: {
    title: 'Schließen Sie sich 500+ erfolgreichen Händlern an',
    intro: 'Werden Sie Teil unseres wachsenden Netzwerks professioneller Partner in ganz Europa und profitieren Sie von exklusiven Vorteilen.',
    benefit1: {
      title: 'Exklusive Gebietsrechte',
      description: 'Sichern Sie sich Ihr Territorium und minimieren Sie den Wettbewerb in Ihrer Region.'
    },
    benefit2: {
      title: 'Umfassende Produktschulung',
      description: 'Regelmäßige Schulungen zu Produkten, Installation und Verkaufstechniken.'
    },
    benefit3: {
      title: 'Marketing & Vertriebsunterstützung',
      description: 'Professionelle Materialien und Kampagnen zur Unterstützung Ihres Geschäfts.'
    },
    benefit4: {
      title: 'Technischer Support',
      description: 'Direkter Zugang zu unserem Expertenteam für alle technischen Fragen.'
    },
    benefit5: {
      title: 'Flexible Lieferoptionen',
      description: 'Dropshipping, Lagerbestand oder Projektlieferung – Sie wählen.'
    },
    stats: {
      dealers: 'Aktive Händler',
      countries: 'Länder',
      satisfaction: 'Zufriedenheit'
    },
    cta: 'Starten Sie Ihre Anmeldung'
  },
  dealerProcess: {
    badge: 'EINFACHER PROZESS',
    title: 'In 3 Schritten Offizieller Händler',
    step1: {
      title: 'Anmelden',
      description: 'Füllen Sie das Online-Formular mit Ihren Geschäftsdaten aus',
      time: '2 Minuten'
    },
    step2: {
      title: 'Verifizierung',
      description: 'Wir prüfen Ihre Angaben und kontaktieren Sie persönlich',
      time: '1-2 Tage'
    },
    step3: {
      title: 'Aktivierung',
      description: 'Erhalten Sie Zugang zum Händlerportal und beginnen Sie',
      time: 'Sofort'
    },
    reassurance: 'Keine Verpflichtungen • Kostenlose Anmeldung • Persönlicher Kontakt',
    cta: 'Anmeldeformular ausfüllen'
  },
  testimonials: {
    label: 'WAS HÄNDLER SAGEN',
    title: 'Vertraut von Professionals',
    dealerSince: 'Händler seit'
  },
  productShowcase: {
    title: 'Entdecken Sie unsere Kollektion',
    subtitle: 'Alle Produkte verfügbar über unser Händlerportal',
    moreInfo: 'Mehr Informationen',
    viewAll: 'Alle Produkte ansehen',
    productsFound: 'Produkte gefunden',
    noProducts: 'Keine Produkte in dieser Kategorie gefunden'
  },
  resources: {
    downloads: {
      title: 'Händler Resources',
      catalog: 'Produktkatalog 2025',
      technicalSpecs: 'Technische Spezifikationen',
      installationGuide: 'Installationsanleitung',
      marketingMaterials: 'Marketingmaterialien'
    },
    support: {
      title: 'Wir helfen Ihnen gerne',
      contactText: 'Kontaktieren Sie uns für Händler-Support',
      email: 'E-Mail Support',
      emailResponse: 'Antwort innerhalb 24h'
    }
  },
  footer: {
    tagline: 'Premium B2B Kaminlösungen',
    newsletter: {
      placeholder: 'Ihre geschäftliche E-Mail-Adresse',
      disclaimer: 'Nur für Geschäftskunden'
    },
    products: 'Produkte',
    information: 'Information',
    contact: 'Kontakt',
    copyright: '© 2025 Dutch Fires',
    businessOnly: 'Nur für Geschäftskunden',
    legal: {
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      terms: 'AGB',
      cookies: 'Cookies'
    }
  },
  common: {
    learnMore: 'Mehr erfahren',
    contactUs: 'Kontaktieren Sie uns'
  },
  cookies: {
    title: 'Cookie-Einstellungen',
    description: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und unsere Website zu analysieren. Sie können Ihre Einstellungen jederzeit anpassen.',
    settings: 'Einstellungen',
    necessaryOnly: 'Nur notwendige',
    acceptAll: 'Alle akzeptieren',
    settingsTitle: 'Cookie-Einstellungen verwalten',
    savePreferences: 'Einstellungen speichern',
    alwaysOn: 'Immer an',
    necessary: {
      title: 'Notwendige Cookies',
      description: 'Diese Cookies sind für die Grundfunktionen der Website erforderlich und können nicht deaktiviert werden.'
    },
    analytics: {
      title: 'Analyse-Cookies',
      description: 'Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren.'
    },
    marketing: {
      title: 'Marketing-Cookies',
      description: 'Diese Cookies werden verwendet, um Werbung relevanter für Sie zu gestalten.'
    }
  },
  productCTA: {
    b2bOnly: 'Nur B2B',
    dealerOnly: 'Nur für Händler',
    title: 'Interesse an diesem Produkt?',
    titleWithProduct: 'Interesse an {{product}}?',
    description: 'Werden Sie offizieller Dutch Fires Händler und erhalten Sie Zugang zu Großhandelspreisen, exklusiven Konditionen und vollständiger Unterstützung.',
    interestedInProduct: 'Interesse an {{product}}? Werden Sie Händler für Preise und Bestellungen.',
    interestedGeneral: 'Interesse an unseren Produkten? Werden Sie Händler für Preise und Bestellungen.',
    inlineTitle: 'Preise nur für registrierte Händler verfügbar',
    benefit1: 'Zugang zu Großhandelspreisen',
    benefit2: 'Exklusive Händlerkonditionen',
    benefit3: 'Persönliche Betreuung',
    becomeDealer: 'Händler werden',
    ctaButton: 'Jetzt Händler werden',
    disclaimer: 'Nur für Unternehmen mit gültiger Registrierung',
    viewDetails: 'Details ansehen'
  }
};